import { Link } from "react-router-dom";

// Beach Umbrella SVG Logo
const BeachUmbrellaLogo = ({ className = "w-10 h-10" }) => (
  <svg viewBox="0 0 100 100" className={className}>
    <circle cx="50" cy="50" r="48" fill="#0EA5E9" />
    <path d="M50 20 C25 20 15 45 15 45 L50 45 Z" fill="#EF4444" />
    <path d="M50 20 C55 20 62 28 67 45 L50 45 Z" fill="#FBBF24" />
    <path d="M67 45 C72 45 80 42 85 45 L50 45 C50 45 60 20 50 20 C60 20 75 25 85 45 Z" fill="#F97316" />
    <path d="M50 20 C40 20 30 28 23 45 L50 45 Z" fill="#FBBF24" />
    <rect x="48" y="45" width="4" height="30" fill="#8B5CF6" rx="1" />
    <ellipse cx="50" cy="78" rx="18" ry="6" fill="#FDE68A" />
    <ellipse cx="50" cy="78" rx="12" ry="4" fill="#FCD34D" />
  </svg>
);

const Footer = () => {
  return (
    <footer className="bg-[#0EA5E9]" data-testid="footer">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Logo & Description */}
          <div className="flex flex-col items-center md:items-start">
            <Link to="/" className="flex items-center gap-2 group mb-4">
              <BeachUmbrellaLogo className="w-12 h-12" />
              <div>
                <span className="font-extrabold text-xl text-white font-['Outfit']">PublicBeachAccess</span>
                <span className="text-[#FDE68A] font-bold">.com</span>
              </div>
            </Link>
            <p className="text-white/80 text-sm text-center md:text-left">
              Find public beach access points across the United States. ☀️🏖️
            </p>
          </div>

          {/* Quick Links */}
          <div className="flex flex-col items-center md:items-start">
            <h3 className="font-bold text-white mb-4">Quick Links</h3>
            <div className="flex flex-col gap-2">
              <Link to="/search" className="text-white/80 hover:text-[#FDE68A] text-sm transition-colors">
                Find Beaches
              </Link>
              <Link to="/map" className="text-white/80 hover:text-[#FDE68A] text-sm transition-colors">
                Beach Map
              </Link>
              <Link to="/blog" className="text-white/80 hover:text-[#FDE68A] text-sm transition-colors">
                Articles
              </Link>
              <Link to="/contact" className="text-white/80 hover:text-[#FDE68A] text-sm transition-colors">
                Contact Us
              </Link>
            </div>
          </div>

          {/* Legal Links */}
          <div className="flex flex-col items-center md:items-start">
            <h3 className="font-bold text-white mb-4">Legal</h3>
            <div className="flex flex-col gap-2">
              <Link to="/data-disclaimer" className="text-white/80 hover:text-[#FDE68A] text-sm transition-colors">
                Data Disclaimer
              </Link>
              <Link to="/accessibility-statement" className="text-white/80 hover:text-[#FDE68A] text-sm transition-colors">
                Accessibility Statement
              </Link>
              <Link to="/terms" className="text-white/80 hover:text-[#FDE68A] text-sm transition-colors">
                Terms of Service
              </Link>
              <Link to="/privacy" className="text-white/80 hover:text-[#FDE68A] text-sm transition-colors">
                Privacy Policy
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Disclaimer Bar */}
      <div className="bg-[#0284C7] py-3">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-white/70 text-xs text-center italic">
            Information is deemed reliable but not guaranteed. Lifeguard presence is not guaranteed and may vary. Please verify all information before your visit.
          </p>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="bg-[#0369A1] py-4">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-2">
            <p className="text-white/60 text-sm">
              © {new Date().getFullYear()} Digital Properties, LLC. All rights reserved.
            </p>
            <p className="text-white/80 text-sm">
              Website Designed By{" "}
              <a
                href="https://bp.agency"
                target="_blank"
                rel="noopener noreferrer"
                className="font-bold text-[#FDE68A] hover:text-white transition-colors"
              >
                Brand Partners
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
